import React, { useEffect } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { setCampaign } from "../../Storage/Redux/campaignSlice";
import { useNavigate } from "react-router-dom";
import { useGetQuizesQuery } from "../../Apis/quizApi";
import { QuizModel } from "../../Interfaces/QuizModel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

export default function QuizList() {
  const { data, isLoading } = useGetQuizesQuery(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && data?.result) {
      dispatch(setCampaign(data.result));
    }
  }, [isLoading, data, dispatch]);

  const handleRowClick = (quizID: number) => {
    navigate(`/Quiz/Details/${quizID}`);
  };

  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 3,
        overflow: "hidden",
      }}
    >
      <CardHeader
        sx={{background:"#f8f8f8"}}
        title={
          <Typography
            variant="h6"
            sx={{ color: "#eb3c96", fontWeight: "bold", m: 0 }}
          >
            Quiz List
          </Typography>
        }
      />
      <CardContent>
        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Table
            size="small"
            sx={{
              "& tbody tr:hover": {
                backgroundColor: "rgba(81, 35, 132, 0.05)",
                cursor: "pointer",
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>#</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Start Date</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>End Date</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.result?.length > 0 ? (
                data.result.map((quiz: QuizModel, index: number) => (
                  <TableRow
                    key={quiz.id}
                    onClick={() => handleRowClick(quiz.id)}
                    hover
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{quiz.name}</TableCell>
                    <TableCell>
                      {new Date(quiz.startDate).toLocaleDateString()}
                    </TableCell>
                    <TableCell>
                      {new Date(quiz.endDate).toLocaleDateString()}
                    </TableCell>
                    <TableCell>
                      {quiz.isActive ? (
                        <CheckCircleIcon color="success" />
                      ) : (
                        <CancelIcon color="error" />
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <Typography color="text.secondary">
                      No quizzes found.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
